import { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { Header, Footer } from '../';

import './layout.scss';

const Layout = ({ pageId, settings, children }) => {
  const [isVisible, setVisibility] = useState(false);

  const handleScroll = () => {
    setVisibility(window.scrollY > 250);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div id={pageId}>
      <Header contacts={settings?.contacts} logo={settings?.logos.header_logo} />
      <main>{children}</main>
      <Footer contacts={settings?.contacts} logo={settings?.logos.footer_logo} />
      <ToastContainer />
      <div className={`mobile-cta-buttons ${isVisible ? 'on' : 'off'}`}>
        <a href={`tel:${settings?.contacts.phone}`}>{settings?.contacts.phone}</a>
        <NavLink to="/book-now" state={{ prevLocation: window.location.pathname.split('/')[1] }}>
          Schedule a Service
        </NavLink>
      </div>
    </div>
  );
};

export default Layout;
